
import '../App.css';
import Banner from './Banner/Banner';
import Fairepart from './FairePart/Fairepart';
import Sondage from './SondageForm/Sondage.js';
import Adresses from './Adresses/Adresses.js'
import MyParticles from './Particles/MyParticles.js';
import Cagnotte from './Cagnotte/Cagnotte.js';

export default function Home() {
  return (
    <>
      <Banner></Banner>
      <MyParticles></MyParticles>
      <div id="container">
        <Fairepart></Fairepart>
        <Sondage></Sondage>
        <Adresses></Adresses>
        {/* <Cagnotte></Cagnotte> */}
      </div>
    </>
    
  );
}
